import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import CityState from '../CityState';
import { paymentService } from 'services/PaymentService';
import { getCeps } from 'services/LocationService';
import { ISearchCep } from 'interfaces/ISearchCep';
import TableCep from './TableCep/index';
import FieldText from 'components/Field/Text';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { SvgIcon } from 'components/SvgIcon';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  model: ISearchCep;
  open: boolean;
  msgErro: string;
  infos: any;
}

interface IProps {
  onClose?: Function;
  isFullScreen: boolean;
}

@WithStyles(() => ({
  '@global': {
    '.theme_18': {
      '& .chk-searchCEP-modal': {
        width: '550px',
        margin: '60px auto',
        overflow: 'visible',

        '@media screen and (max-width: 480px)': {
          width: '100vw',
          maxHeight: '100vh',
          height: '100vh',
          margin: 0
        },

        '& .chk-searchCEP__closeButtonGrid': {
          backgroundColor: '#FFF',
          position: 'fixed',
          zIndex: 1,
          width: '535px',

          '@media screen and (max-width: 480px)': {
            width: '100%'
          }
        },

        '& .chk-cityState__city': {
          marginTop: '8px'
        },

        '& .chk-cityState__state': {
          marginTop: '8px',
          fontSize: '1rem'
        },

        '& .list-on-bottom': {
          margin: '0 0 8px 0'
        },
      }
    },

    '.theme_14, .theme_16': {
      '& .chk-searchCEP-modal': {
        width: '550px',
        margin: '60px auto',
        overflow: 'visible',

        '@media screen and (max-width: 480px)': {
          width: '100vw',
          maxHeight: '100vh',
          height: '100vh',
          margin: 0
        },

        '& .chk-searchCEP__closeButtonGrid': {
          backgroundColor: '#FFF',
          position: 'fixed',
          width: '535px',

          '@media screen and (max-width: 480px)': {
            width: '100%'
          }
        }
      },

      '& .list-on-bottom': {
        margin: '0 0 8px 0'
      },
    }
  },
  component: {
    padding: '4px 0',

    '& .chk-searchCEP-modal': {
      position: 'relative',
      backgroundColor: 'white',
      overflow: 'hidden'
    },

    '& .chk-searchCEP__modalTitle': {
      '& h2': {
        fontSize: '1.125rem'
      }
    },

    '& .chk-searchCEP__dialogActions': {
      margin: '16px 0 0 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },

    '& .chk-searchCEP__closeButton': {
      top: 0,
      right: 0,
      position: 'absolute',
      padding: '20px 16px 0 0',
      cursor: 'pointer',

      '& svg': {
        width: '8px'
      }
    },

    '& .chk-searchCEP__confirmButton': {
      fontWeight: 600,
      letterSpacing: '0.5px',
      borderRadius: '3px',
      color: '#009358',
      fontSize: '0.875rem',
      padding: '7px 18px',
      margin: '16px 0 0 10px',

      '@media screen and (max-width: 480px)': {
        width: '100%',
        marginLeft: 0
      },
    },

    '& .chk-msg-erro': {
      color: 'red'
    },

    '& .field-select': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1rem',
      border: '1px solid #d9d9d9',
      padding: '0px 5px 0px 8px',
      minHeight: '43px'
    },

    '& .chk-tableCEP__addressList': {
      '& .chk-tableCEP__address': {
        cursor: 'pointer'
      }
    },

    '& .chk-cityState__state label, & .chk-cityState__city label, & .field.normal label': {
      transform: 'translate(0, 0) scale(0.75)'
    },

    '& .chk-cityState__state, & .chk-cityState__city': {
      '& input': {
        border: '1px solid #d9d9d9',
        padding: '10px 8px'
      }
    },
  }
}))
export default class SearchCEP extends BaseComponent<IState, IProps> {
  constructor(props: any) {
    super(props);

    this.state = { model: null, open: false, msgErro: '', infos: {} };
  }

  componentDidMount() {
    this.bindModel(paymentService.getAddress());
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose && this.props.onClose();
    this.setState({ open: false });
  };

  search = () => {
    getCeps(this.state.model)
      .loader()
      .bindComponent(this)
      .subscribe(
        result => {
          if (result.length == 0) {
            this.setState({ msgErro: 'CEP não encontrado :(', infos: result });
            return;
          }
          this.setState({ infos: result });
        },
        err => {
          console.log(err);
        }
      );
  };

  render() {
    if (!this.state.model) {
      return <div />;
    }

    const { open, model } = this.state;

    return (
      <div className={this.props.classes.component}>
        <a id="searc-cep" href="#" className="chk-searchCEP__button theme-label" onClick={this.handleOpen}>
          Não sei meu CEP
        </a>
        <Modal
          aria-labelledby="Buscar CEP"
          aria-describedby="Preencha os dados de endereço para obter seu CEP"
          open={open}
          onClose={this.handleClose}
          className={this.props.classes.component}
        >
          <div className="chk-searchCEP-modal">
            <DialogTitle className="chk-searchCEP__modalTitle" id="simple-dialog-title">
              <span onClick={this.handleClose} className="chk-searchCEP__closeButton">
                <SvgIcon name="closeIcon" />
              </span>
              Pesquisa de CEP
            </DialogTitle>
            <DialogContent style={{ overflow: 'visible' }}>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <CityState
                    value={{ city: '', province: '' }}
                    disableAutocompleteOnProvince
                    onChange={this.updateModel(result => {
                      model.province = result.province;
                      model.city = result.city;
                    })}
                  />
                </Grid>
                {model.city && (
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid className="grow" item align-content="stretch">
                        <FieldText
                          id="street"
                          label="Endereço"
                          validation="required"
                          value={model.street}
                          onChange={this.updateModel(street => (model.street = street))}
                          inputProps={{
                            className: 'theme-input'
                          }}
                          InputLabelProps={{
                            className: 'theme-label',
                            id: 'label-search-postal-code-street'
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          id="chk-searchcep-button"
                          onClick={this.search}
                          size="large"
                          color="primary"
                          className="chk-searchCEP__confirmButton theme-button"
                        >
                          Buscar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              {this.state.infos.length > 0 ? (
                <TableCep handleClose={this.handleClose} data={this.state.infos} />
              ) : (
                <p className={'chk-msg-erro'}>{this.state.msgErro}</p>
              )}
            </DialogContent>
          </div>
        </Modal>
      </div>
    );
  }
}
